export default __webpack_public_path__ + "static/certificate-kids-vertical-182b929d34beb2f62c049be2a6f384b5.png";